/**
 * Used for remembering the filtering of the markets list page
 */
import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const MarketFilterStorageKey = 'moxieMarketFilter'
export const marketFilterAtom = atomWithStorage<
    Record<
        string,
        {
            filterText: string
            includeDeleted: boolean
        }
    >
>(MarketFilterStorageKey, {}, undefined, {
    getOnInit: true,
})

export const useMarketFilter = (clientCode: string) => {
    const [marketFilter] = useAtom(marketFilterAtom)
    return marketFilter[clientCode] || { filterText: '', includeDeleted: false }
}

export const useSetMarketFilterText = (clientCode: string) => {
    const [marketFilter, setMarketFilter] = useAtom(marketFilterAtom)
    return (filterText: string) =>
        setMarketFilter({
            ...marketFilter,
            [clientCode]: { ...marketFilter[clientCode], filterText },
        })
}

export const useSetMarketFilterIncludeDeleted = (clientCode: string) => {
    const [marketFilter, setMarketFilter] = useAtom(marketFilterAtom)
    return (includeDeleted: boolean) =>
        setMarketFilter({
            ...marketFilter,
            [clientCode]: { ...marketFilter[clientCode], includeDeleted },
        })
}
